//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    lang: {
      type: String,
      default: 'th'
    }
  },
  computed: {
    info: function info() {
      var lang = this.lang,
        form = this.form;
      var year = +this.$util.parseTime(new Date(), '{y}');
      var cName = lang === 'th' ? form.c_name_th : form.c_name_en;
      // 语言表示
      var langS = lang === 'th' ? form.th_language : form.en_language;
      // 企业简称
      var shortName = (lang === 'th' ? form.c_short_name_th : form.c_short_name_en) || '';
      // 日期时间
      var formateDate = String(form.date_format === 1 && lang === 'th' ? year + 543 : year);
      return {
        cName: cName,
        // 模版编号
        // 企业简称-语言标识00000-年份
        version: (shortName ? shortName + '-' : shortName) + langS + '00000' + '-' + formateDate
      };
    }
  }
};